import { Grid, Skeleton, Stack } from "@mui/material";
import ContentWrapper from "../../components/ContentWrapper";
import styles from "./ConfirmationPage.module.css";
import React from "react";

export default function ConfirmationSkeleton() {
	function dataTableSkeleton(rows: number) {
		return (
			<>
				<Stack direction="row" justifyContent="space-between">
					<Skeleton height="24px" width="25%" />
					<Skeleton variant="rectangular" height="35px" width="78px" />
				</Stack>
				<Grid container columnSpacing={2} rowSpacing={"10px"}>
					{Array.from({ length: rows }).map((_, idx) => (
						<React.Fragment key={idx}>
							<Grid item xs={3}>
								<Skeleton height="18px" />
							</Grid>
							<Grid item xs={9}>
								<Skeleton height="18px" />
							</Grid>
						</React.Fragment>
					))}
				</Grid>
			</>
		);
	}

	return (
		<div className={styles.pageWrapper}>
			<ContentWrapper>
				<Skeleton height="24px" />
				<Skeleton height="24px" />
				<div className={styles.configWrapper}>
					<div>{dataTableSkeleton(4)}</div>
					<div>{dataTableSkeleton(3)}</div>
					<div>
						<Stack direction="row" justifyContent="space-between" marginBottom="15px">
							<Skeleton height="24px" width="25%" />
							<Skeleton variant="rectangular" height="35px" width="78px" />
						</Stack>
						<Skeleton variant="rectangular" height="100px" />
					</div>
				</div>
			</ContentWrapper>
		</div>
	);
}
